import { struct } from 'io-ts/Decoder';

import { EntityId } from '../../../../integration/EntityId';
import { RequestData } from '../../link/RequestData';

export const RequestItem = struct({
	entityId: EntityId,
	data: RequestData,
});
